import BaseApi from "./BaseApi";

class AbandonedSignUpApi extends BaseApi {
  constructor() {
    super("asu");
  }
}

export default AbandonedSignUpApi;
